export function handleProductClick(ev) {
    if (window.ga && window.ga.loaded) {
        var href = $(this).attr("href");
        var parent = $(this).parents("div[data-position]");
        if (href && parent) {
            var product = {
                id: parent.data("style"),
                name: parent.data("name"),
                category: parent.data("category"),
                list: parent.data("list"),
                price: parent.data("price"),
                position: parent.data("position")
            };
            var color = $(this).data("color");
            if (color) {
                product.variant = color;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "productClick",
                ecommerce: {
                    click: {
                        actionField: { list: parent.data("list") },
                        products: [product]
                    }
                },
                eventCallback: function() {
                    document.location = href;
                }
            });
            ev.preventDefault();
            return false;
        }
    }
}

export function impressionsLoaded() {
    var impressions = $("div[data-position]")
        .map(function() {
            var product = {
                id: $(this).data("style"),
                name: $(this).data("name"),
                category: $(this).data("category"),
                list: $(this).data("list"),
                price: $(this).data("price"),
                position: $(this).data("position")
            };
            var color = $(this).data("color");
            if (color) {
                product.variant = color;
            }
            return product;
        })
        .get();

    if (impressions.length) {
        window.dataLayer.push({
            ecommerce: {
                currencyCode: "USD",
                impressions: impressions.slice(0, 10)
            },
            event: "impressionsLoaded"
        });
    }
}

export function loadVisible() {
    var topPadding = Math.max(
        0,
        $(".adjusted-container").innerHeight() - $(".adjusted-container").height()
    );
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    $("img[data-scroll-src]").each(function() {
        var elemTop = $(this).offset().top;
        if (elemTop - topPadding <= docViewBottom && elemTop + topPadding >= docViewTop) {
            $(this)
                .removeClass("img-loading-container")
                .attr("src", $(this).data("scroll-src"))
                .removeData("scroll-src");
        }
    });
}

export function leadConversion(event, label) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "GAEvent",
        eventCategory: event,
        eventAction: "conversion",
        eventLabel: label || "",
        eventValue: ""
    });
    window.dataLayer.push({
        event: "FBEvent",
        facebookEvent: {
            type: "Lead"
        }
    });
    window.dataLayer.push({ event: "emailSubscribe" });
}

export function productCompare() {
    var items = $(".product-compare input:checked");
    if (items.length >= 2) {
        var styles = $.map(items, function(item) {
            return $(item).data("style");
        });

        // Enable 'Compare Now'
        var href = "/product/compare/" + styles.join(",");
        $(items)
            .siblings(".compare-now")
            .attr("href", href)
            .show();
        $(items)
            .siblings(".compare-add")
            .hide();

        $(".product-compare input:not(:checked)")
            .siblings(".compare-add")
            .show();
        $(".product-compare input:not(:checked)")
            .siblings(".compare-now")
            .hide();

        if (items.length >= 4) {
            // Disable further additions
            $(".product-compare input:not(:checked)").attr("disabled", "disabled");
        } else {
            $(".product-compare input").removeAttr("disabled");
        }
    } else {
        // Remove 'Compare Now'
        $(".product-compare .compare-add").show();
        $(".product-compare .compare-now").hide();
        $(".product-compare input").removeAttr("disabled");
    }
}

export function isMobileDevice() {
    var a = navigator.userAgent || navigator.vendor || window.opera;
    if (/mobi|tablet/i.test(a)) {
        return 1;
    }
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 769 ? 1 : 0;
}

export function sizechartBindings() {
    function selectSizeChart() {
        const sizechart = $("button[data-sizechart].active").data("sizechart");
        const unit = $("button[data-sizeunits].active").data("sizeunits");
        let selector = ".sizechart-";
        if (sizechart == "P") {
            selector += "petite-";
        }
        selector += unit;
        $(".sizechart").hide();
        $(selector).show();
    }

    $("button[data-sizechart]")
        .unbind()
        .click(function() {
            $("button[data-sizechart]").removeClass("active");
            $(this).addClass("active");
            selectSizeChart();
        });

    $("button[data-sizeunits]")
        .unbind()
        .click(function() {
            $("button[data-sizeunits]").removeClass("active");
            $(this).addClass("active");
            selectSizeChart();
        });

    selectSizeChart();
}

/*
function countryTypeAhead(country) {
    // select * from (select distinct countryID from countries join geonames on geonames.country_code = countries.countrycode) x order by countryID;
    var typeAheadSupported = [1,2,5,6,10,13,14,22,31,34,47,50,51,54,55,57,65,67,68,69,74,78,80,81,88,89,90,95,98,108,109,111,114,117,118,119,122,124,125,133,134,135,140,148,149,150,151,154,155,156,159,166,169,171,173,185,186,190,194,201,204,208,213,214,217,221,222,257,263,265,280,282,291,292,295,297,307,313,314,325];
    return $.inArray(parseInt(country), typeAheadSupported) >= 0 ? true : false;
}
window.countryTypeAhead = countryTypeAhead;
*/

export default {
    productCompare: productCompare,
    loadVisible: loadVisible,
    handleProductClick: handleProductClick,
    leadConversion: leadConversion,
    impressionsLoaded: impressionsLoaded,
    isMobileDevice: isMobileDevice
};
